import { Network } from '@haechi-labs/face-types';
// TODO: find better place to locate this
// ref: https://haechilabs.slack.com/archives/C04HTNZH5D5/p1701743842199579
const nexonAppApiKeys = [
    // Nexon Dapp Key
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCsY-w2HRh6VwRfOw5P7pMvQzxf3Hz3dOurwCeV4AHmVWpxh-DfQx8aKL8394dJVy7x2geVeKR62rSl58HsFsr9utgvHb7PzZluV6DlDQJKrsHIjYiOSKVadMUgNHV40NgrzQggxuOY0MhJ599GWeXps_PPzWv7hsLircae1PnVOQIDAQAB',
    // allow for QA apps
    // ref: https://haechilabs.slack.com/archives/C03RPALDC3S/p1701765113196749?thread_ts=1701763773.998949&cid=C03RPALDC3S
    // PM Dapp key for QA
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCnh7y9sFxoFWwjP9Xlg7s9kXqfRGMusccEFr-LcvzyfPrFohvaKw0YLdMdb8trgK5M5VCEGWJ8p_sMSwb6i_MkQwv2s711uKxHAasUmDtX6eMy3eNKowdZo5nXraQpQd529c0jtZt5l07ryHHts3k4MF0W83GpaoWgjSLXhMEK8QIDAQAB',
    // PM Dapp key for PT -> PM 마이그레이션
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCYU6H6iw3iACEavvEXxrsZ-erPAB-oR6xngU8Mugw-y89umz77r1KJHJFnGG7jdjrHC211CUijwL4y8jpt_NCNefsAayFcBHOQElp-So_uaebTIBrkqEH4i3qkr0xJtH1HmNfsrcwWyE4sztRqmCLHG7KJDDsjXVsigsPqQwRKXwIDAQAB',
    // PT Dapp key for QA
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCqBmCzkl0ClfF_yuegA44dL5KGOq4BxtQlizFKFjh3VR2zIyHmp8Y6aFXhLmuJjiyRvZXi9K_dA0mEH458U9pf7iffGZOEa8fRELachZmd2-dZuI6mdL7XrNPY8XNPG4EcCtp3GVVefSr3dKEaTaBl6c0BUBWRBcpWLkX0cSe2bQIDAQAB',
    // ST Dapp key for QA
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCS23ncDS7x8nmTuK1FFN0EfYo0vo6xhTBMBNWVbQsufv60X8hv3-TbAQ3JIyMEhLo-c-31oYrvrQ0G2e9j8yvJYEUnLuE-PaABo0y3V5m9g_qdTB5p9eEfqZlDrcUl1zUr4W7rJwFwkTlAFSKOqVCPnm8ozmcMyyrEHgl2AbehrQIDAQAB',
];
const nexonPsmNetworks = new Set([
    // TODO: PSM 삭제
    Network.PSM,
    Network.PSM_TESTNET,
    Network.PSM_TESTNET_DEV,
    Network.PSM_TESTNET_TEST,
]);
const nexonAsmNetworks = new Set([
    // Network.ASM,
    Network.ASM_QA,
    Network.ASM_TEST,
    Network.ASM_DEV,
    Network.ASM_STAGE,
]);
function isNexonByApiKey(apiKey) {
    return nexonAppApiKeys.includes(apiKey);
}
export function filterNexonNetworks(apiKey, previousNetworks) {
    if (isNexonByApiKey(apiKey)) {
        return previousNetworks;
    }
    const nextNetworks = new Set(previousNetworks);
    for (const blockchain of nexonPsmNetworks) {
        nextNetworks.delete(blockchain);
    }
    for (const blockchain of nexonAsmNetworks) {
        nextNetworks.delete(blockchain);
    }
    return nextNetworks;
}
export function filterNexonNetworksWithNetworkGetter(apiKey, items, networkGetter) {
    if (isNexonByApiKey(apiKey)) {
        return items;
    }
    const filteredItems = [];
    for (const item of items) {
        const network = networkGetter(item);
        if (nexonPsmNetworks.has(network) || nexonAsmNetworks.has(network)) {
            continue;
        }
        filteredItems.push(item);
    }
    return filteredItems;
}
//# sourceMappingURL=nexon.js.map